module.exports = __webpack_public_path__ + "img/title_white.863bdef6.png";